export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '5fb9a386-7db2-43e7-be11-2443d016ab99';
export const MODAL_CLOSE_SEC = 2.5;
